import type { HeaderButtonProps } from 'src/components/layout/redesign/header-mobile/header-button';
import type { BuildType } from 'src/enums/build/build-type';
import type { Language } from 'src/enums/language';
import { amplitudeButtonTrackEvent } from 'src/helpers/amplitude-event-track';

export const buttonProps = (
  buttonProps: Queries.RedesignButton | undefined,
  buildType: BuildType,
  ctaName: string,
  componentName: string,
  language: Language,
  handleMenuOpen?: (value: boolean) => void
): HeaderButtonProps | undefined =>
  buttonProps
    ? {
        type: 'link',
        buttonProps,
        handleClick: () => {
          handleMenuOpen?.(false);
          void amplitudeButtonTrackEvent({
            buildType,
            language,
            button: buttonProps,
            ctaName,
            componentName,
            formName: null,
          });
        },
      }
    : undefined;
